import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * [{"name": "nav_<page name>", "isActivated": true, "isPrivate": false}, ...]
 * 
 */
@Component({
  template: `
<div>
  <div>
    <label>{{ label | translate }}</label>
  </div>
  <div *ngFor="let page of value">
    <input-active-private
      [displayPrivate]="true"
      [name]="'sessions.content.navigation.pages.names.' + page.name | translate"
      [(active)]="page.isActivated"
      [(private)]="page.isPrivate"
    ></input-active-private>
  </div>
  <div class="legend m-t-lg">
    <i class="fa fa-unlock-alt"></i><span>{{ 'sessions.content.navigation.pages.legend_public' | translate }}</span><br/>
    <i class="fa fa-lock" style="color:darkred;"></i><span>{{ 'sessions.content.navigation.pages.legend_private' | translate }}</span>
  </div>
  <div>
</div>
`,
  styles: [`
  .legend {
    padding-left: 15px;
  }
  .legend span {
    padding-left: 10px;
  }
`],
  selector: 'eevent-pages'
})
export class EeventPagesComponent implements OnInit {

  @Input('label') public label: string;

  private _value: any[];
  @Output() public valueChange = new EventEmitter<any[]>();
  public get value(): any[] {
    return this._value;
  }
  @Input() public set value(v: any[]) {
    if (Array.isArray(v) && v.length > 0) {
      this._value = v;
    } else {
      this._value = this.defaultPages();
      this.valueChange.emit(this._value);
    }
  }

  constructor() {
  }

  ngOnInit() {
  }

  private defaultPages() {
    return [
      {"name": "nav_home", "isActivated": true, "isPrivate": false},
      {"name": "nav_schedule", "isActivated": false, "isPrivate": false},
      {"name": "nav_livespace", "isActivated": false, "isPrivate": false},
      {"name": "nav_speakers", "isActivated": false, "isPrivate": false},
      {"name": "nav_sponsors", "isActivated": false, "isPrivate": false},
      {"name": "nav_documents", "isActivated": false, "isPrivate": false},
      {"name": "nav_survey", "isActivated": false, "isPrivate": false},
      {"name": "nav_practicalinfos", "isActivated": false, "isPrivate": false},
      {"name": "nav_networking", "isActivated": false, "isPrivate": true},
      {"name": "nav_newsfeed", "isActivated": false, "isPrivate": true},
      {"name": "nav_ebadge", "isActivated": false, "isPrivate": true},
      {"name": "nav_profile", "isActivated": false, "isPrivate": true}
    ];
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/eevent.pages.component.ts